import type { RouteRecordRaw } from 'vue-router';
import md from '@/router/middlewares';
import roles from '@/constants/roles';

const component: RouteRecordRaw = {
    path: 'components/:componentId',
    component: () => import('@/views/sites/ComponentPage.vue'),
    meta: {
        middlewares: [md.getComponentInfo],
        title: 'sitePage.components',
        img: 'SiteTree.svg',
        hidden: true,
    },
    children: [
        {
            path: 'analysisTypes/:analysisTypeId',
            component: () => import('@/views/sites/AnalysisTypePage.vue'),
            meta: {
                middlewares: [md.getAnalysisTypeInfo],
                title: 'sitePage.analysisTypes',
                img: 'Analysis.svg',
                allowedRoles: [roles.ADMINISTRATOR.value, roles.MANAGER.value],
            },
            redirect: { name: 'history' },
            children: [
                {
                    path: 'history',
                    name: 'history',
                    component: () => import('@/views/sites/MeasureHistory.vue'),
                },
            ],
        },
    ],
};

export default component;
